import {ErrorModel} from '../../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../../root';
import {expenses} from './defaultResponseModel/expenses';
const FUNCTION_CODE = 'GET_ADMIN_DASHBOARD_EXPENSES';

export async function getExpenses(userToken: string, params: string) {
    try {
        const response = await axios.get(
            `${URL}/dashboards/partner/expenses/${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return expenses.from(response.data);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
